import "../styles/Booking.css"

function Booking({ isOpen, setIsOpen }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={() => setIsOpen(false)}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>
        <h2>Choose How to Book</h2>
        <div className="booking-options">
          <a className="modal-btn" href="https://wa.me/message/EDJFTG2UTN57L1" target="_blank" rel="noreferrer">💬 WhatsApp</a>
          <a className="modal-btn" href="mailto:lufitcollective@gmail.com" target="_blank" rel="noreferrer">📧 Email</a>
          <a className="modal-btn" href="https://instagram.com/lufit_collective" target="_blank" rel="noreferrer">📸 Instagram</a>
          <a className="modal-btn" href="tel:+27671045485">📞 Call +254 712 345 678</a>
        </div>
      </div>
    </div>
  );
}


export default Booking;